import styled from "styled-components";

const colors = {
  default_base_orange: "#FF9800",
};

export const Container = styled.div`
  .MuiBadge-colorPrimary {
    background: ${colors.default_base_orange};
    width: 24px;
    height: 24px;
    border-radius: 50%;
    cursor: default;
    z-index: 0;
  }
`;
